module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1017-c9e9606ec9946f11ad18dce363686f4d.png";